var windowWidth, lazyLink, lazyImages, lazyBackground, lazyIframe, lazyScripts, navigator_platform, lazyLoadedJS, s, i, j, flag;
function init() {
  1 == flag && ((flag = 0), lazyLoadImg(), load_all_js(), lazyLoadBackground(), lazyLoadIframe());
}
function isElementInViewport(e) {
  "function" == typeof jQuery && e instanceof jQuery && (e = e[0]);
  var t = e.getBoundingClientRect();
  return t.top >= 0 && t.left >= 0 && t.bottom <= (window.innerHeight || document.documentElement.clientHeight) && t.right <= (window.innerWidth || document.documentElement.clientWidth);
}
function lazyLoadLink() {
  lazyLink.forEach(function (e) {
    e.href = null == e.dataset.href ? e.href : e.dataset.href;
  });
}
function lazyLoadImg() {
  lazyImages.forEach(function (e) {
    (e.src = windowWidth < 600 ? (null == e.dataset.mobsrc ? e.dataset.src : e.dataset.mobsrc) : e.dataset.src), e.classList.remove("lazyImage");
  });
}
function lazyLoadBackground() {
  lazyBackground.forEach(function (e) {
    (e.style = windowWidth < 600 ? (null == e.dataset.mobstyle ? e.dataset.style : e.dataset.mobstyle) : e.dataset.style), e.classList.remove("lazyBackground");
  });
}
function lazyLoadIframe() {
  document.getElementsByTagName("html")[0].classList.add("lazy_js"),
    lazyIframe.forEach(function (e) {
      e.src = null == e.dataset.src ? e.src : e.dataset.src;
    });
}
function lazyLoadScripts() {
  j != lazyScripts.length && ("lazyScript" == lazyScripts[j].getAttribute("type")
      ? (lazyScripts[j].setAttribute("type", "lazyloaded"),
        void 0 !== lazyScripts[j].dataset.src
          ? (((s = document.createElement("script")).src = lazyScripts[j].dataset.src),
            document.body.appendChild(s),
            (s.onload = function () {
              j++, lazyLoadScripts();
            }))
          : (((s = document.createElement("script")).innerHTML = lazyScripts[j].innerHTML), document.body.appendChild(s), j++, lazyLoadScripts()))
      : (j++, lazyLoadScripts()));
}
function lazyLoadCss(e) {
  ((s = document.createElement("link")).rel = "stylesheet"), (s.href = e), document.getElementsByTagName("head")[0].appendChild(s);
}
function lazyLoadJS(e) {
  lazyLoadedJS &&
    (setTimeout(function () {
      lazyLoadJS(e);
    }, 200),
    (lazyLoadedJS = 0)),
    (lazyLoadedJS = 1),
    ((s = document.createElement("script")).src = e),
    (s.onload = function () {
      lazyLoadedJS = 0;
    }),
    document.body.appendChild(s);
}
function load_all_js() {
    setTimeout(function () {
      var e = new Event("opt_load");
      window.dispatchEvent(e);
    }, 200),
    (j = 0),
    (lazyScripts = document.getElementsByTagName("script")),
    lazyLoadScripts(),
    setInterval(function () {
      (lazyImages = document.querySelectorAll("img.lazyImage")), (lazyBackground = document.querySelectorAll(".lazyBackground")), lazyLoadImg(), lazyLoadBackground();
    }, 3e3);
}
document.addEventListener("DOMContentLoaded", function () {
  (windowWidth = screen.width),
    (lazyLink = document.querySelectorAll("link")),
    (lazyImages = document.querySelectorAll("img.lazyImage")),
    (lazyBackground = document.querySelectorAll(".lazyBackground")),
    (navigator_platform = navigator.platform),
    (lazyIframe = document.querySelectorAll("iframe")),
    (lazyScripts = document.getElementsByTagName("script")),
    (i = 0),
    (j = 0),
    (flag = 1),
    "Linux x86_64" != navigator_platform && init(),
    window.addEventListener("scroll", function () {
      init();
    }),
    window.addEventListener("mousemove", function () {
      init();
    }),
    window.addEventListener("click", function () {
      init();
    }),
    window.addEventListener("touchstart", function () {
      init();
    }),
    setTimeout(function () {
      init();
    }, 99999);
});
